import { activeAccessToken } from './AuthorizationHelpers'

export function authHeader() {
  const { token } = activeAccessToken
  return { Authorization: `Bearer ${token}`, Public: false }
  // // return authorization header with jwt token
  // const user = JSON.parse(localStorage.getItem('user'))

  // if (user && user.token) {
  //   return { Authorization: 'Bearer ' + user.token }
  // } else {
  //   return {}
  // }
}

export function getAuthHeader() {
  return authHeader().Authorization
}

export function getShareTokenAuthHeader(token) {
  return { 'X-Share-Token': token, Public: true }
}
